module.exports = __webpack_public_path__ + "img/82.17d0fd33.jpg";